<template fluid>
  <div>
    <v-overlay v-if="refreshghost && antighost" opacity="1.00" z-index="500" color="#FFFFFF">
    </v-overlay>
    <main>
      <transition mode="out-in">
        <router-view />
      </transition>
    </main>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
        refreshghost: 'refreshghost',
        antighost: 'antighost'
    }),
  },
}
</script>
